/**
 * ゲームイベント → SE 名の判定（src/audio/INTEGRATION.md の対応表に準拠）。
 *
 * applyMove 前後の state（コア契約のプレーンオブジェクト）だけから判定する
 * 純粋関数 — DOM / three.js / Web Audio 非依存で node テスト可能。
 * 実際の再生は main.js が audio.playSe(seForMove(prev, next)) で行う。
 */

/**
 * prev = applyMove 前の state, next = applyMove 後の state。
 * 返値は SE 名（audio モジュールの SE_NAMES のいずれか）または null（無音）。
 */
export function seForMove(prev, next) {
  const move = next.history[next.history.length - 1];
  const mover = prev.current; // 手を指したプレイヤー

  if (next.winner !== null) return 'win';

  if (move.type === 'wall') return 'wall';

  if (move.type === 'ability') {
    // 忍者の壁越えジャンプだけ 'jump'、それ以外（removeWall / diagonalStep）は 'ability'
    return move.ability === 'wallJump' ? 'jump' : 'ability';
  }

  if (move.type === 'move') {
    // 移動して沼にはまった → swamp を優先
    if (next.players[mover].effects && next.players[mover].effects.swamped) {
      return 'swamp';
    }

    const from = prev.players[mover].pawn;
    const to = move.to;
    const opp = prev.players[1 - mover].pawn;
    const dist = Math.abs(to.col - from.col) + Math.abs(to.row - from.row);

    if (dist <= 1) return 'move';

    // dist >= 2: 対面ジャンプ（相手駒が from に隣接し、着地が相手駒の周囲1マス）
    const oppAdjacent =
      Math.abs(opp.col - from.col) + Math.abs(opp.row - from.row) === 1;
    const landsAroundOpp =
      Math.abs(to.col - opp.col) <= 1 && Math.abs(to.row - opp.row) <= 1;
    if (oppAdjacent && landsAroundOpp) return 'jump';

    return 'slide'; // それ以外の距離2以上 = 氷滑走
  }

  return null; // 'pass' などは無音
}
